<template>
    <div class="withdraw_wrap">
		<div class="red_top_bg">
		    <div class="back_left" @click="$router.go(-1)"></div>
		    <div class="big_tit">{{$t('transfer.title')}}</div>
			<div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div>
		</div>
		<div  class="transfer-container pd30">
		    <div  class=" flex mb40 account-wrap">
		        <div  class="card plr30 flex-one ">
		            <div  class=" card-body flex-column flex-center pd30 bglight">
		                <div  class=" title">{{$t('transfer.tuiacc')}}</div>
		                <div  class=" num mt20">{{data.money}} {{utils_moneyMark()}}</div>
		            </div>
		        </div>
				<van-icon name="minus" size="25"/>
		        <van-icon name="arrow" size="25"/>
		        <div  class=" card plr30 flex-one ">
		            <div  class=" card-body flex-column flex-center pd30 bglight">
		                <div  class=" title">{{$t('transfer.accc')}}</div>
		                <div  class=" num mt20">{{data.baoku_money}} {{utils_moneyMark()}}</div>
		            </div>
		        </div>
		    </div>
		    <div  class="input">
		        <div class="uni-input">
		            <div class="uni-input-wrapper">
		                <input v-model="number" maxlength="10" :placeholder="$t('transfer.input')"  type="number" class="uni-input-input">
		        	</div>
		        </div>
		    </div>
		    <div class="basic_btn"  @click="sure">{{$t('transfer.sure')}}</div>
		</div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "cost",
        data() {
            return {
                data: {},
                number: ''
            };
        },
        created() {
			this.$parent.footer('user', true);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(2);
					this.data.baoku_money = this.data.baoku_money.toFixed(2);
                });
            },
            sure() {
				var number = parseFloat(this.number);
                if (!number) {
                    this.$toast(this.$t('transfer.amountEmpty'));
                    return false;
                }
                if(number < 0){
                    this.$toast(this.$t('transfer.amountNotAllow'));
                    return false;
                }
				if(number > parseFloat(this.data.money)){
                    this.$toast(this.$t('transfer.amountHigh'));
                    return false;
                }
                
                Fetch('/user/transfer', {
                    money: number
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('transfer.success')
                    });
                    this.$router.replace('/vip')
                });
            }
        }
    };
</script>

<style lang="less" scoped>
	
	.transfer-container .main-container {
	    background-color: #f0f3f7;
	    border-radius: 5.33333vw;
	}
	.pd30 {
	    padding: 4vw;
	}
	
	.mb40 {
	    margin-bottom: 5.33333vw!important;
	}
	.flex {
	    display: flex;
	}
	.transfer-container .card {
	    height: 22.93333vw;
	}
	.plr30 {
	    padding-left: 4vw;
	    padding-right: 4vw;
	}
	.flex-one {
	    flex: 1;
	}
	.transfer-container .main-container {
	    background-color: #f0f3f7;
	    border-radius: 5.33333vw
	}
	
	.transfer-container .card {
	    height: 22.93333vw
	}
	
	.transfer-container .card .card-body {
	    border-radius: 4vw;
		text-align: center;
	}
	
	.transfer-container .card .title {
	    font-size: 80%
	}
	
	.transfer-container .card .num {
	    font-size: 4vw;
	    font-weight: 700;
	    color: #0063d2
	}
	
	.transfer-container .form-group {
	    height: 8.8vw;
	    color: #495057;
	    border: .5px solid #ced4da;
	    border-radius: 4.8vw;
	    background-color: #fff
	}
	
	.transfer-container .form-group .uni-input {
	    height: 100%
	}
	
	.transfer-container .confirm-btn {
	    height: 8.8vw;
	    background-color: #ff2768;
	    color: #fff;
	    border-radius: 6.4vw
	}
	.input {
	    position: relative;
	    height: 35px;
	    background: #fff;
	    margin-bottom: 16px;
	    border: 1px solid #ddd;
	    border-radius:3vw;
	    overflow: hidden;
		.uni-input {
		    width: 100%;
		    height: 34px;
		    text-indent: 16px;
		    font-size: 16px;
		    background: #fff;
			.uni-input-wrapper{
				display: flex;
				position: relative;
				width: 100%;
				height: 100%;
			}
			.uni-input-input {
			    position: relative;
			    display: block;
			    height: 100%;
			    background: 0 0;
			    color: inherit;
			    opacity: 1;
				width: 100%;
			    font: inherit;
			    line-height: inherit;
			    letter-spacing: inherit;
			    text-align: inherit;
			    text-indent: inherit;
			    text-transform: inherit;
			    text-shadow: inherit;
			}
		}
		span {
		    position: absolute;
		    right: -1px;
		    top: -1px;
		    font-size: 14px;
		    font-weight: 500;
		    height: 34px;
		    line-height: 34px;
		    padding: 0 16px;
		    background: #3b58a4;
		    color: #fff;
		    border-radius: 0 17px 17px 0;
		}
	}
	.transfer-container .card .title {
	    font-size: 80%;
		line-height: 30px;
	}
	.transfer-container .card .num {
	    font-size: 4vw;
	    font-weight: 700;
	    color: #0063d2;
	}
	.basic_btn {
		width: auto;
	}
	.transfer-container i{
		margin-top: 25px;
		color: #FFF;
	}
</style>
